<section class="payment-details ps-4 pt-3">
    <app-back-button url="/payment-history"> BACK </app-back-button>
    @if (!isLoading && paymentDetailsSection && paymentDetailsSection.length) {
        <div class="p-4 pt-3 d-flex flex-column w-100">
            <h1>Payment Detail:</h1>
            @if (customerInformation) {
                <mat-card class="mb-4 p-3 rounded-2 customer-container">
                    <app-details-header>
                        <span class="my-3"><strong>Customer information</strong></span>
                    </app-details-header>
                    <div class="row">
                        @for (item of this.customerInformation; let itemIndex = $index; track itemIndex) {
                            @if (item.show) {
                                <app-details-field
                                    class="col-12 col-md-4"
                                    [label]="item.label ?? ''"
                                    [value]="item.value"
                                />
                            }
                        }
                    </div>
                </mat-card>
            }
            <mat-accordion class="mb-2">
                @for (payment of paymentDetails; track payment; let i = $index; let isFirst = $first) {
                    <mat-expansion-panel [expanded]="isFirst" #panel>
                        <mat-expansion-panel-header class="bar-color px-3 expansion-panel-header rounded-bottom-0">
                            <mat-panel-title class="d-flex mat-subtitle-1 align-items-center m-0">
                                Primary facility reference #: {{ payment.awb + ' - ' + payment.paymentType }}
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        @defer (when isFirst; on interaction(panel)) {
                            <div class="row pt-3">
                                <app-details-header>
                                    <span class="my-3"><strong>Payment details</strong></span>
                                </app-details-header>
                                @if (paymentDetailsSection && paymentDetailsSection[i]) {
                                    @for (field of paymentDetailsSection[i]; track $index) {
                                        @if (field.show) {
                                            <app-details-field
                                                class="col-12 col-md-4"
                                                [label]="field.label ?? ''"
                                                [value]="field.value"
                                            />
                                        }
                                    }
                                }
                                @for (field of dynamicFields; let fieldIndex = $index; track fieldIndex) {
                                    @if (field.show) {
                                        <app-details-field
                                            class="col-12 col-md-4"
                                            [label]="field.label ?? ''"
                                            [value]="field.value"
                                        />
                                    }
                                }
                                <app-files-container [filesPath]="files" />
                            </div>
                            <app-customer-reference [paymentDetail]="payment" />
                            <app-company-customer-reference [paymentDetails]="payment" />
                        }
                    </mat-expansion-panel>
                }
            </mat-accordion>
        </div>
    } @else if (isLoading) {
        <div class="h-100 d-flex flex-column justify-content-center align-items-center">
            <mat-spinner diameter="40" class="mb-3" />
        </div>
    } @else {
        <section id="no_information" class="container-fluid">
            <div class="d-flex flex-column h-100 justify-content-center align-items-center">
                <div class="row">
                    <div class="col-12">
                        <img
                            class="mx-auto d-block"
                            ngSrc="assets/{{ facilityName }}/img/empty.svg"
                            alt="No information illustration"
                            width="290"
                            height="190"
                        />
                    </div>
                    <div class="col-12">
                        <h4 class="d-block text-center mt-4 mb-3 fs-2">You don't have any data!</h4>
                        <h4 class="d-block text-center mt-4 mb-3 fs-3">Looking good so far!</h4>
                    </div>
                </div>
            </div>
        </section>
    }
</section>
